//@import dependencies
import React, {useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
//@end

//@import components
import ReactSelectComponent from 'app_components/commons/reactSelect'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../bannerModule.scss'
import moment from 'moment';
import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent';

// @ADD Component types
interface IBannerModuleLayoutProps {
  onHandleSubmit: (data: any) => void
  editData?: any
  viewer: boolean
}

const BannerModuleLayout: React.FC<IBannerModuleLayoutProps> = (props) => {

  const [isActive, setIsActive] = useState<boolean>(false)
  const [listOfLocation] = useState<Array<any>>([
    {
      value: 'guest',
      label: 'Landing principal'
    },
    {
      value: 'student_landing',
      label: 'Landing estudiantes'
    },
  ])
  const [currentLocations, updateCurrentLocations] = useState<{value: string, label: string, name: string}[]>([]);

  const { t } = useTranslation()
  const formHook = useForm()

  useEffect(() => {
    if (props?.editData) {
      setIsActive((props?.editData?.details?.isActive) ? props?.editData?.details?.isActive : false)
    }
  }, [props,props.editData])

  const handleChangeIsActive = (e: any) => {
    setIsActive(!isActive)
  }

  const getDefaultValueLocations = () => {
    if (props?.editData?.details?.locations?.length) {
      const locationsByValue = listOfLocation.reduce((accum, element) => {
        if (!accum[element.value]) {
          accum[element.value] = element
        }
        return accum;
      }, {})
      const _options = props?.editData?.details?.locations.map((r: any) => {
        const item = locationsByValue[r]
        return item
      });
      return _options;
    } else {
      return [];
    }
  }

  console.log(formHook.errors)

  return(
    <div className='banner-form'>
      <fieldset disabled={props.viewer ? true : false}>
        <form onSubmit={formHook.handleSubmit(props.onHandleSubmit)}>

          <div className="d-flex align-items-center mb-2">
            <h3 className="form-title">{t("modules.banners.general_information")}</h3>
          </div>

          <div className="row">
            <div className="col-md-12 switch-is-active">
              <div className="form-group">
                <Form.Check
                  type='switch'
                  id='isActive'
                  name='isActive'
                  label={t('labels.banners.isActive')}
                  onChange={(event: any) => handleChangeIsActive(event)}
                  checked={isActive}
                  ref={formHook.register()}
                />
              </div>
            </div>
          </div>

          <div className="d-flex align-items-center mb-2">
            <h3 className="form-title">{t("modules.banners.content")}</h3>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className='form-group '>
                <label htmlFor='title'>{t('labels.banners.title')}</label>
                {formHook.errors.title && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <input
                  id='title'
                  name='title'
                  className={`form-control ${formHook.errors.title && 'is-invalid'}`}
                  type='text'
                  ref={formHook.register({ required: true,
                    maxLength: {
                      value: 40,
                      message: 'El campo no puede tener mas de 40 caracteres'
                    }
                  })}
                  defaultValue={props?.editData?.details?.title}
                />
                <LabelComponent color={formHook.errors.title?.type === "maxLength" ? 'red' : undefined}>
                  Máximo 40 caracteres
                </LabelComponent>
              </div>
            </div>
            <div className="col-md-12">
              <div className='form-group '>
                <label htmlFor='content'>{t('labels.banners.content')}</label>
                {formHook.errors.content && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <textarea
                  id='content'
                  name='content'
                  className={`form-control ${formHook.errors.content && 'is-invalid'}`}
                  ref={formHook.register({ required: true,
                    maxLength: {
                      value: 128,
                      message: 'El campo no puede tener mas de 128 caracteres'
                    }
                  })}
                  defaultValue={props?.editData?.details?.content}
                />
                <LabelComponent color={formHook.errors.title?.type === "maxLength" ? 'red' : undefined}>
                  Máximo 128 caracteres
                </LabelComponent>
              </div>
            </div>

            <div className="col-md-6">
              <div className='form-group'>
                <label htmlFor='cover'>{t('labels.banners.cover')}</label>
                {formHook.errors.cover && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <input
                  id='cover'
                  name='cover'
                  className='form-control-file'
                  type='file'
                  ref={formHook.register({ required: false })}
                />
                {formHook.errors.cover && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>
            {props?.editData?.details?.coverUrl && (
              <div className="col-md-6">
                <div className="form-group">
                    <div className="cover-container">
                      <img src={props?.editData?.details?.coverUrl} alt=""/>
                    </div>
                </div>
              </div>
            )}
            <div className="col-md-12">
              <div className='form-group '>
                <label htmlFor='action'>{t('labels.banners.action')}</label>
                <input
                  id='action'
                  name='action'
                  className={`form-control ${formHook.errors.action && 'is-invalid'}`}
                  type='text'
                  ref={formHook.register()}
                  defaultValue={props?.editData?.details?.action}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className='form-group '>
                <label htmlFor='actionText'>Texto del botón mas información</label>
                <input
                  id='actionText'
                  name='actionText'
                  className={`form-control ${formHook.errors.actionText && 'is-invalid'}`}
                  type='text'
                  ref={formHook.register()}
                  defaultValue={props?.editData?.details?.actionText}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className='form-group '>
                <label htmlFor='registerUrl'>{t('labels.banners.register')}</label>
                <input
                  id='registerUrl'
                  name='registerUrl'
                  className={`form-control ${formHook.errors.registerUrl && 'is-invalid'}`}
                  type='text'
                  ref={formHook.register()}
                  defaultValue={props?.editData?.details?.registerUrl}
                />
              </div>
            </div>
            <div className="col-md-12">
            <Form.Group controlId="exampleForm.ControlSelect1">
              <Form.Label>Posición de la caja de texto</Form.Label>
              <Form.Control
                name='positionOnScreen'
                as="select"
                ref={formHook.register()}
                defaultValue={props?.editData?.details?.positionOnScreen ? props?.editData?.details?.positionOnScreen : 'left'}
              >
                <option value='left'>Izquierda</option>
                <option value='center'>Centro</option>
                <option value='right'>Derecha</option>
              </Form.Control>
            </Form.Group>
            </div>
            <div className="col-md-12">
                <div className="form-group">
                  <label htmlFor='locations'>{t('labels.banners.locations')}</label>
                  <ReactSelectComponent
                    identifier='locations'
                    options={listOfLocation}
                    formHooks={formHook}
                    defaultValue={getDefaultValueLocations()}
                    isMulti={true}
                    required={true}
                    onChangeSelect={(data: any) => updateCurrentLocations(data ? data : [])}
                  />
                  {formHook.errors.locations && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                </div>
              </div>
            {/* <div className="col-md-12">
              <label htmlFor=''>{t('labels.banners.location')}<br/></label>
              <div className='form-group '>
                <label
                  htmlFor='location'
                  style={{
                    display: 'flex',
                    gap: '8px',
                    alignItems: 'center'
                  }}
                >
                  <input
                    id='location'
                    name='location'
                    type='checkbox'
                    value='students'
                    ref={formHook.register()}
                    defaultChecked={props?.editData?.details?.location === 'students' ? true : undefined}
                  />
                  {t('labels.banners.students')}
                </label>
              </div>
            </div> */}
          </div>

          <div className="d-flex align-items-center mb-2">
            <h3 className="form-title">{t("modules.banners.publish_date")}</h3>
          </div>
          <div className="col-md-12">
            <div className='form-group '>
              <label htmlFor='start_date'>{t('labels.banners.start_date')}</label>
              <input
                id='start_date'
                name='start_date'
                className={`form-control ${formHook.errors.start_date && 'is-invalid'}`}
                type='date'
                ref={formHook.register()}
                defaultValue={props?.editData?.details?.start_date ? moment(props?.editData?.details?.start_date).add(1, 'day').format('YYYY-MM-DD') : undefined}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className='form-group '>
              <label htmlFor='end_date'>{t('labels.banners.end_date')}</label>
              <input
                id='end_date'
                name='end_date'
                className={`form-control ${formHook.errors.end_date && 'is-invalid'}`}
                type='date'
                ref={formHook.register()}
                defaultValue={props?.editData?.details?.end_date ? moment(props?.editData?.details?.end_date).add(1, 'day').format('YYYY-MM-DD') : undefined}
              />
            </div>
          </div>

          {!props.viewer && (
            <div className='buttons-group'>
              <div className='text-right'>
                <button className='btn btn-primary' type='submit'>
                  {t('buttons.save')}
                </button>
              </div>
            </div>
          )}
        </form>
      </fieldset>
    </div>
  )
}

export default BannerModuleLayout
